import { render, staticRenderFns } from "./editPromoSignup.vue?vue&type=template&id=3861119b&lang=pug"
import script from "./editPromoSignup.vue?vue&type=script&lang=js"
export * from "./editPromoSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports